import { api } from "#/lib/api-client";

const B = "/api/hr/admin/email-queue";

export type EmailQueueStatus = "PENDING" | "PROCESSING" | "SENT" | "FAILED" | "CANCELLED" | string;

export type EmailQueueItem = {
  id: number;
  toAddresses: string;          // comma-separated string per API spec
  subject: string;
  eventType?: string | null;
  referenceType?: string | null;
  referenceId?: number | null;
  status: EmailQueueStatus;
  attempts: number;
  maxAttempts?: number;
  scheduledFor?: string | null;
  sentAt?: string | null;
  lastError?: string | null;
  createdAt?: string;
};

export type PageResponse<T> = {
  content: T[];
  totalElements: number;
  totalPages: number;
  number: number;
  size: number;
  first: boolean;
  last: boolean;
};

export const emailQueueApi = {
  list(params: { page?: number; size?: number; status?: string } = {}): Promise<PageResponse<EmailQueueItem>> {
    const p: Record<string, string> = { page: String(params.page ?? 0), size: String(params.size ?? 20) };
    if (params.status) p.status = params.status;
    return api.get<PageResponse<EmailQueueItem>>(B, { params: p }).then(r => r.data);
  },
  retry(id: number): Promise<EmailQueueItem> {
    return api.post<EmailQueueItem>(`${B}/${id}/retry`).then(r => r.data);
  },
  cancel(id: number): Promise<EmailQueueItem> {
    return api.post<EmailQueueItem>(`${B}/${id}/cancel`).then(r => r.data);
  },
};
